import logger from '@/utils/logger.js'
import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/store'
import WillkommenView from '../views/WillkommenView.vue'
import AboutView from '../views/AboutView.vue'
import AdminView from '../views/AdminView.vue'
import CharakterView from '../views/CharakterView.vue'
import CharDNDView from '../views/CharDNDView.vue'
import CharDSAView from '../views/CharDSAView.vue'
import CharGötterlichtView from '../views/CharGötterlichtView.vue'
import CharSRView from '../views/CharSRView.vue'
import EinstellungenView from '../views/EinstellungenView.vue'
import MeineCharaktereView from '../views/MeineCharaktereView.vue'
import WürfeltoolView from '../views/WürfeltoolView.vue'
import LoginView from '../views/LoginView.vue'
import GamemasterView from '../views/GamemasterView.vue'
import KampagneView from '../views/KampagneView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: WillkommenView
  },
  {
    path: '/about',
    name: 'AboutView',
    component: AboutView
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: AboutView
  },
  {
    path: '/admin',
    name: 'AdminView',
    component: AdminView,
    meta: { requiresAuth: true }
  },
  {
    path: '/charakter',
    name: 'CharakterView',
    component: CharakterView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dndcharakter',
    name: 'CharDNDView',
    component: CharDNDView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dsacharakter',
    name: 'CharDSAView',
    component: CharDSAView,
    meta: { requiresAuth: true }
  },
  {
    path: '/glcharakter',
    name: 'CharGLView',
    component: CharGötterlichtView,
    meta: { requiresAuth: true }
  },
  {
    path: '/srcharakter',
    name: 'CharSRView',
    component: CharSRView,
    meta: { requiresAuth: true }
  },
  {
    path: '/einstellungen',
    name: 'EinstellungenView',
    component: EinstellungenView,
    meta: { requiresAuth: true }
  },
  {
    path: '/charaktere',
    name: 'MeineCharaktereView',
    component: MeineCharaktereView,
    meta: { requiresAuth: true }
  },
  {
    path: '/wtool',
    name: 'WürfeltoolView',
    component: WürfeltoolView
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/gamemaster',
    name: 'GamemasterView',
    component: GamemasterView,
    meta: { requiresAuth: true }
  },
  {
    path: '/kampagne',
    name: 'KampagneView',
    component: KampagneView,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Auth-bewusster Guard: Vor jedem Wechsel auf die Firebase-Auth-Initialisierung
// warten, damit ein Reload/Deep-Link auf geschützten Routen nicht fälschlich auf
// die Startseite umgeleitet wird (E1).
router.beforeEach(async (to) => {
  await store.dispatch('initAuth')
  if (to.meta.requiresAuth && !store.state.User) {
    logger.log('Auf Willkommensseite umgeleitet.')
    return { name: 'home' }
  }
  return true
})

export default router
